import type { ShopOrderView } from "@frontier/content/shop";

export function shopOrderMessage(order: ShopOrderView): string {
  if (order.state === "closed") return "Неоплаченный заказ закрыт.";
  if (order.state === "refunded")
    return order.testMode
      ? "Тестовый возврат подтверждён."
      : "Возврат подтверждён VK.";
  if (order.state === "charged")
    return order.testMode
      ? "Тестовый платёж подтверждён."
      : "Ресурсы начислены.";
  return "Ожидаем подтверждение платежа от VK.";
}
